export interface AppVersionInfo {
  version: string;
  date: string;
}

export function loadAppVersion(): void {
  const s = document.createElement('script');
  s.setAttribute('src', 'version.js?cacheBusting=' + new Date().getTime());
  document.body.appendChild(s);
}

export function getAppVersion(): AppVersionInfo | undefined {
  return (window as { eswAppVersion?: AppVersionInfo }).eswAppVersion;
}
